/* COLOMBY COFFEE — 2026 layer: blend cards */
(function () {
  'use strict';

  /* Plain / spiced switch on blend cards: swaps photo, name, price and
     link in place. No request, no reload. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cbx-kind]');
    if (!btn) return;
    var card = btn.closest('[data-cbx-blend]');
    if (!card) return;
    var kind = btn.getAttribute('data-cbx-kind');
    if (card.getAttribute('data-kind') === kind) return;
    var url = card.getAttribute('data-url-' + kind);
    if (!url) return;

    card.setAttribute('data-kind', kind);
    card.querySelectorAll('[data-cbx-kind]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    card.querySelectorAll('[data-cbx-link]').forEach(function (a) { a.setAttribute('href', url); });
    var name = card.querySelector('[data-cbx-name]');
    if (name) name.textContent = card.getAttribute('data-name-' + kind) || name.textContent;
    var price = card.querySelector('[data-cbx-price]');
    if (price) price.textContent = card.getAttribute('data-price-' + kind) || price.textContent;

    /* The spiced photo is lazy; make sure it is requested on first switch. */
    var img = card.querySelector('.cbx-blend__img--' + kind);
    if (img && img.loading === 'lazy') img.loading = 'eager';
  });

  /* ---------- Blend builder ("اعمل توليفتك") ---------- */
  var STRENGTH = ['', 'خفيفة جدًا', 'خفيفة', 'متوسطة', 'تقيلة', 'تقيلة جدًا'];
  var BITTER = ['', 'من غير مرارة', 'خفيفة', 'متوسطة', 'واضحة', 'قوية'];
  var ROAST_COLOR = { 'فاتح': '#b9824f', 'وسط': '#7a4a2a', 'غامق': '#3a2216' };

  function optIndex(names, word) {
    for (var i = 0; i < names.length; i++) if (String(names[i]).indexOf(word) !== -1) return i;
    return -1;
  }

  function initBuilder(root) {
    if (root._cbxInit) return;
    root._cbxInit = true;
    var dataEl = root.querySelector('[data-cbx-bb-data]');
    var form = root.querySelector('[data-cbx-bb-form]');
    if (!dataEl || !form) return;
    var blends;
    try { blends = JSON.parse(dataEl.textContent); } catch (err) { return; }
    if (!blends.length) return;

    blends.forEach(function (p) {
      p.ri = optIndex(p.o, 'تحميص');
      p.ki = optIndex(p.o, 'النوع');
      p.si = optIndex(p.o, 'حجم');
      p.roasts = {};
      p.kinds = {};
      p.v.forEach(function (v) {
        if (p.ri > -1) p.roasts[v.o[p.ri]] = true;
        if (p.ki > -1) p.kinds[v.o[p.ki]] = true;
      });
    });

    var q = function (sel) { return root.querySelector(sel); };
    var cup = q('.cbx-bb__cup');
    var card = q('[data-cbx-card]');
    var last = null;

    function state() {
      var fd = new FormData(form);
      return {
        roast: fd.get('roast'),
        strength: parseInt(fd.get('strength'), 10),
        bitter: parseInt(fd.get('bitter'), 10),
        kind: fd.get('kind'),
        size: fd.get('size')
      };
    }

    function score(p, s) {
      var d = Math.abs(s.strength - p.s) + Math.abs(s.bitter - p.b);
      var sc = 100 - d * 10;
      if (p.ri > -1 && !p.roasts[s.roast]) sc -= 22;
      if (p.ki > -1 && !p.kinds[s.kind]) sc -= 22;
      return Math.max(35, Math.min(99, Math.round(sc)));
    }

    function pickVariant(p, s) {
      function ok(v, needRoast, needKind, needSize) {
        if (needRoast && p.ri > -1 && v.o[p.ri] !== s.roast) return false;
        if (needKind && p.ki > -1 && v.o[p.ki] !== s.kind) return false;
        if (needSize && p.si > -1 && v.o[p.si] !== s.size) return false;
        return true;
      }
      var tries = [[1, 1, 1], [0, 1, 1], [1, 1, 0], [0, 1, 0], [1, 0, 1], [0, 0, 1], [0, 0, 0]];
      for (var t = 0; t < tries.length; t++) {
        for (var i = 0; i < p.v.length; i++) {
          var v = p.v[i];
          if (v.a && ok(v, tries[t][0], tries[t][1], tries[t][2])) return v;
        }
      }
      return p.v[0];
    }

    function li(text) {
      var el = document.createElement('li');
      el.textContent = text;
      return el;
    }

    function render() {
      var s = state();
      var outS = q('[data-cbx-out="strength"]');
      var outB = q('[data-cbx-out="bitter"]');
      if (outS) outS.textContent = STRENGTH[s.strength];
      if (outB) outB.textContent = BITTER[s.bitter];

      cup.style.setProperty('--roast', ROAST_COLOR[s.roast] || '#7a4a2a');
      cup.style.setProperty('--str', s.strength);
      cup.classList.toggle('is-spiced', s.kind === 'محوج');
      var kindLabel = s.kind === 'محوج' ? 'محوّج' : 'سادة';
      q('[data-cbx-summary]').textContent = s.roast + ' • ' + STRENGTH[s.strength] + ' • ' + kindLabel;

      var ranked = blends.map(function (p, i) { return { p: p, sc: score(p, s), i: i }; })
        .sort(function (a, b) { return b.sc - a.sc || a.i - b.i; });
      var best = ranked[0];
      var p = best.p;
      var v = pickVariant(p, s);
      var spiced = p.ki > -1 && v.o[p.ki] === 'محوج';

      card.style.setProperty('--blend', p.bg);
      card.style.setProperty('--blend-ink', p.ink);
      q('[data-cbx-latin]').textContent = p.l;
      q('[data-cbx-name]').textContent = spiced ? p.t + ' محوّج' : p.t;
      q('[data-cbx-score]').textContent = best.sc + '%';
      q('[data-cbx-price]').textContent = v.p;
      q('[data-cbx-id]').value = v.id;
      var add = q('[data-cbx-add]');
      if (add) add.disabled = !v.a;
      var url = p.u + (p.u.indexOf('?') > -1 ? '&' : '?') + 'variant=' + v.id;
      q('[data-cbx-url]').setAttribute('href', url);
      var img = q('.cbx-bb__card-media img');
      if (img && v.img) {
        img.removeAttribute('srcset');
        img.src = v.img;
        img.loading = 'eager';
        img.alt = p.t;
      }

      var why = q('[data-cbx-why]');
      why.textContent = '';
      if (p.n) why.appendChild(li(p.n));
      if (p.ri > -1) {
        var vr = v.o[p.ri];
        why.appendChild(li(vr === s.roast ? 'متاحة بالتحميص ' + vr : 'مش متاحة ' + s.roast + '، هتجيلك ' + vr));
      }
      why.appendChild(li('قوتها ' + STRENGTH[p.s] + '، ومرارتها ' + BITTER[p.b]));

      var alt = q('[data-cbx-alt]');
      var second = ranked[1];
      if (alt && second) {
        alt.hidden = false;
        alt.textContent = '';
        alt.appendChild(document.createTextNode('وممكن كمان تجرّب '));
        var a = document.createElement('a');
        var v2 = pickVariant(second.p, s);
        a.href = second.p.u + (second.p.u.indexOf('?') > -1 ? '&' : '?') + 'variant=' + v2.id;
        a.textContent = second.p.t;
        alt.appendChild(a);
        alt.appendChild(document.createTextNode(' (' + second.sc + '%)'));
      }

      var peekName = q('[data-cbx-peek-name]');
      var peekScore = q('[data-cbx-peek-score]');
      if (peekName) peekName.textContent = q('[data-cbx-name]').textContent;
      if (peekScore) peekScore.textContent = best.sc + '%';

      if (last !== null && last !== p.t) {
        card.classList.remove('is-new');
        void card.offsetWidth;
        card.classList.add('is-new');
      }
      last = p.t;
    }

    form.addEventListener('input', render);
    form.addEventListener('change', render);
    render();
  }

  function initBuilders(scope) {
    (scope || document).querySelectorAll('[data-cbx-bb]').forEach(initBuilder);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initBuilders(); });
  else initBuilders();
  document.addEventListener('shopify:section:load', function (e) { initBuilders(e.target); });
})();
